import { extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { PressResponder } from '@react-aria/interactions';
import React__default, { useRef } from 'react';
import { useId } from 'react-aria';
import { Provider, PopoverContext } from 'react-aria-components';
import { useOverlayTriggerState } from 'react-stately';
import { OverlayTriggerStateContext, DialogContext } from './context.esm.js';
import useOverlayTrigger from '../../../../aria/overlay/use-overlay-trigger.esm.js';

/**
 * A DialogTrigger opens a dialog when a trigger element is pressed.
 */
function DialogTrigger(props) {
  var state = useOverlayTriggerState(props);
  var buttonRef = useRef(null);
  var _useOverlayTrigger = useOverlayTrigger({
      type: 'dialog'
    }, state,
    // @ts-ignore
    buttonRef),
    triggerProps = _useOverlayTrigger.triggerProps,
    overlayProps = _useOverlayTrigger.overlayProps;

  // Label dialog by the trigger as a fallback if there is no title slot.
  // This is done in Aria instead of hooks because otherwise we cannot distinguish
  // between context and props. Normally aria-labelledby overrides the title
  // but when sent by context we want the title to win.
  triggerProps.id = useId();
  // @ts-ignore
  overlayProps['aria-labelledby'] = triggerProps.id;
  return /*#__PURE__*/React__default.createElement(Provider
  // eslint-disable-next-line react-perf/jsx-no-new-array-as-prop
  , {
    values: [[OverlayTriggerStateContext, state], [DialogContext, overlayProps], [PopoverContext, {
      trigger: 'DialogTrigger',
      // @ts-ignore
      triggerRef: buttonRef
    }]]
  }, /*#__PURE__*/React__default.createElement(PressResponder, _extends({}, triggerProps, {
    ref: buttonRef,
    isPressed: state.isOpen
  }), props.children));
}

export { DialogTrigger as default };
//# sourceMappingURL=dialog-trigger.esm.js.map
